<template>
  <!-- 本组件为：特定颜色的饼状图，如周报表格里的饼状图 -->
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import resize from './resize'
import { thousandFn } from '@/utils/thousandFn.js'
import { usedTime } from '@/utils/updateTime.js'
const animationDuration = 6000
import i18n from '@/i18n'
import { temChange, temUnit } from '@/utils/temChange.js'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    seriesData: {
      type: Array,
      default: () => []
    },
    colorArr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null,
      legendData: []
    }
  },
  watch: {
    seriesData: {
      handler(newValue, oldValue) {
        this.seriesData = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      // this.seriesData.forEach(v => {
      //   v.name = (v.name).toUpperCase()
      //   this.legendData.push(v.name)
      // })
      this.initChart()
    }, 500)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
    // 组件销毁前移除监听
    window.removeEventListener('resize', this.resizePerformanceFun)
  },
  methods: {
    initChart() {
      if (this.chart) {
        this.chart.clear()
      }
      this.seriesData.forEach(v => {
        // v.name = (v.name).toUpperCase()
        if (v.divClass == 'myPieChartFirst') {
          if (v.key == 'charge')v.name = i18n.t('yhubReport.ChargingTime')
          if (v.key == 'idel')v.name = i18n.t('basicinfo.Idled')
          if (v.key == 'discharge')v.name = i18n.t('yhubReport.UseTime')
        } else if (v.divClass == 'myPieChartFirst') {
          if (v.key == 'chargeAh')v.name = i18n.t('QR.ChargedAH')
          if (v.key == 'dischargeAh')v.name = i18n.t('QR.dishargedAH')
        }
        this.legendData.push(v.name)
      })
      this.chart = echarts.init(this.$el)
      var myOption = {
        tooltip: {
          trigger: 'item',
          formatter: (b) => {
            var m = thousandFn(b.value) || 0
            if (b.data.divClass == 'myPieChartSecond') {
              return b.name + ': ' + m + ' Ah' +
                    '<br/>' + i18n.t('yhubReport.LowestSOC') + ':\t' + Math.round(b.data.minSoc / 100) + ' %' +
                    '<br/>' + i18n.t('yhubReport.UsedRate') + ':\t' + b.data.usedRate + ' %' +
                    '<br/>' + i18n.t('yhubReport.LowestVol') + ':\t' + b.data.minVoltage / 100 + ' V' +
                    '<br/>' + i18n.t('yhubReport.HighestTem') + ':\t' + temChange(Math.round(b.data.maxTemprature / 100)) + temUnit()
            } else if (b.data.divClass == 'myPieChartFirst') {
              if (b.value) return parseInt((b.value * 1000 % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((b.value * 1000 % (1000 * 60 * 60)) / (1000 * 60)) + ' min '
            } else {
              return b.name + ': ' + m + '(' + b.percent + '%)'
            }
          },
          position: function(p) { // 其中p为当前鼠标的位置
            return [p[0] + 10, p[1] - 10]
          },
          textStyle: {
            align: 'left'
          }
        },
        legend: {
          left: '1%',
          align: 'left',
          top: 'middle',
          type: 'scroll',
          orient: 'vertical',
          data: this.legendData
        },
        grid: {
          // left: '3%',
          // right: '4%',
          // bottom: '15%',
          // top: '2%',
          // containLabel: true
        },
        series: [
          {
            // name: 'WEEKLY WRITE ARTICLES',
            type: 'pie',
            // roseType: 'radius',
            radius: '70%',
            center: ['65%', '50%'],
            selectedMode: 'single',
            color: this.colorArr,
            data: this.seriesData,
            // animationEasing: 'cubicInOut',
            // animationDuration: 2600
            itemStyle: {
              normal: {// 饼状图上的文本显示
                label: {
                  show: true,
                  // formatter: '{b}{c}({d}%)', // 数值和百分比
                  formatter: function(c) {
                    if (c.data.divClass == 'myPieChartFirst') {
                      // return usedTime(c.value * 1000)
                      if (c.value) return parseInt((c.value * 1000 % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((c.value * 1000 % (1000 * 60 * 60)) / (1000 * 60)) + ' min '
                    } else {
                      return thousandFn(c.value) || 0
                    }
                  },
                  textStyle: {
                    fontSize: 12
                  }
                }
              }
            }
          }
        ]
      }
      // if (this.$el.getAttribute('class').indexOf('myPieChartSecond') > -1) {
      //   myOption.tooltip.formatter = this.seriesData.formatter
      // }
      this.chart.setOption(myOption, true)
      //  监听窗口大小改变图表大小（先移除再监听，防止出错）
      window.removeEventListener('resize', this.resizePerformanceFun)
      window.addEventListener('resize', this.resizePerformanceFun)
    },
    resizePerformanceFun() {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>
